import axios from '../api/axios';

export async function getUser(userId) {
  const response = await axios.get(`/users/${userId}`);

  return response.data;
}

export async function changePassword(userId, body) {
  const res = await axios.patch(`/users/${userId}/change-password`, body, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return res.data;
}
